export default "__VITE_ASSET__72b43828__"